import React from 'react';
import { LoginForm, OAuthButtons } from '@components';
import config from '@config';
import { BOTTOM_INDENTS, COLORS, ROUTE_PATHS, TOP_INDENTS } from '@constants';
import { useStore } from '@hooks';
import { AuthLayout } from '@layouts';
import { Divider, RedirectLink, Typography } from '@ui';

const Login = () => {
    const store = useStore();
    const hasUser = store.authStore.hasUser;
    let rightCol;

    if (hasUser) {
        rightCol = (
            <RedirectLink data-e2e='login_sign-up_btn' fontSize='16px' text='Sign up' to={ROUTE_PATHS.REGISTER} />
        );
    } else {
        rightCol = (
            <RedirectLink
                data-e2e='login_request-access_link'
                text='Request Access'
                to={ROUTE_PATHS.REQUEST_ACCESS}
                fontSize='16px'
            />
        );
    }

    return (
        <AuthLayout description='Please log into your account' title='Log in' rightCol={rightCol}>
            <LoginForm />
            {config.isGoogleOauthEnabled || config.isMicrosoftOauthEnabled ? (
                <React.Fragment>
                    <Divider style={{ ...TOP_INDENTS.XL, ...BOTTOM_INDENTS.XL }} topBorder={false}>
                        <Typography.Text type='badgeSmall' color={COLORS.$gray60Black}>
                            Or
                        </Typography.Text>
                    </Divider>
                    <OAuthButtons btnText='Log in' method='sign-in' />
                </React.Fragment>
            ) : null}
        </AuthLayout>
    );
};

export default Login;
